import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useMediaQuery } from "_common/component/MediaQueryProvider";
import MobileWallet from "./MobileWallet";
import DesktopWallet from "./DesktopWallet";

const WalletPage = observer(() => {
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  if (isMobile) return <MobileWallet />;

  return <DesktopWallet />;
});

export default WalletPage;
